module.exports = __webpack_public_path__ + "img/logo-prime-video.14d9f9d2.svg";